import type {TuiCountryIsoCode, TuiLanguage, TuiLanguageCommerce, TuiLanguageCore, TuiLanguageEditor, TuiLanguageKit, TuiLanguageLayout, TuiLanguageTable} from '@taiga-ui/i18n/types';

export const TUI_CZECH_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: ['Číslo', 'Číslo karty'],
    cardExpiry: ['Platnost', 'Datum expirace'],
};

export const TUI_CZECH_LANGUAGE_LAYOUT: TuiLanguageLayout = {
    inputSearch: {
        popular: 'Populární',
        history: 'Historie',
        placeholder: 'Hledat',
        hotkey: 'pro hledání',
        all: 'Vše',
        empty: 'Žádné výsledky',
    },
};

export const TUI_CZECH_LANGUAGE_KIT: TuiLanguageKit = {
    cancel: 'Zrušit',
    done: 'Hotovo',
    more: 'Více',
    otherDate: 'Jiné datum...',
    showAll: 'Zobrazit vše',
    hide: 'Skrýt',
    mobileCalendarTexts: [
        'Vyberte den',
        'Vyberte období',
        'Vyberte dny',
    ],
    range: ['Od', 'Do'],
    countTexts: ['Více', 'Méně'],
    time: {
        'HH:MM': 'HH:MM',
        'HH:MM AA': 'HH:MM AA',
        'HH:MM:SS': 'HH:MM:SS',
        'HH:MM:SS AA': 'HH:MM:SS AA',
        'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
        'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA',
    },
    dateTexts: {
        DMY: 'den.měsíc.rok',
        MDY: 'měsíc.den.rok',
        YMD: 'rok.měsíc.den',
    },
    digitalInformationUnits: ['Byte', 'Kilobyte', 'Megabyte'],
    passwordTexts: ['Zobrazit heslo', 'Skrýt heslo'],
    copyTexts: ['Kopírovat', 'Zkopírováno'],
    shortCalendarMonths: [
        'Led',
        'Úno',
        'Bře',
        'Dub',
        'Kvě',
        'Čvn',
        'Čvc',
        'Srp',
        'Zář',
        'Říj',
        'Lis',
        'Pro',
    ],
    pagination: ['Předchozí strana', 'Další strana'],
    fileTexts: {
        loadingError: 'Chyba načítání',
        preview: 'Náhled',
        remove: 'Odstranit',
    },
    inputFileTexts: {
        defaultLabelSingle: 'nebo ho sem přetáhněte',
        defaultLabelMultiple: 'nebo je sem přetáhněte',
        defaultLinkSingle: 'Vyberte soubor',
        defaultLinkMultiple: 'Vyberte soubory',
        maxSizeRejectionReason: 'Soubor je příliš velký',
        formatRejectionReason: 'Neplatný formát souboru',
        drop: 'Přetáhněte soubor sem',
        dropMultiple: 'Přetáhněte soubory sem',
    },
    multiSelectTexts: {
        all: 'Vybrat vše',
        none: 'Vybrat nic',
    },
    confirm: {
        yes: 'Ano',
        no: 'Ne',
    },
    previewTexts: {
        rotate: 'Otočit',
    },
    zoomTexts: {
        zoomOut: 'Oddálit',
        zoomIn: 'Přiblížit',
        reset: 'Obnovit',
    },
    phoneSearch: 'Hledat zemi nebo kód',
};

export const TUI_CZECH_LANGUAGE_ADDON_EDITOR: TuiLanguageEditor = {
    colorSelectorModeNames: ['Pevná barva', 'Barevný gradient'],
    toolbarTools: {
        undo: 'Zpět',
        redo: 'Znovu',
        font: 'Písmo',
        fontStyle: 'Styl písma',
        fontSize: 'Velikost písma',
        bold: 'Tučné',
        italic: 'Kurzíva',
        underline: 'Podtržení',
        strikeThrough: 'Přeškrtnutí',
        justify: 'Zarovnání',
        justifyLeft: 'Vlevo',
        justifyCenter: 'Na střed',
        justifyRight: 'Vpravo',
        justifyFull: 'Do bloku',
        list: 'Seznam',
        indent: 'Zvětšit odsazení',
        outdent: 'Zmenšit odsazení',
        unorderedList: 'Odrážky',
        orderedList: 'Číslování',
        quote: 'Citace',
        foreColor: 'Barva textu',
        backColor: 'Barva pozadí',
        hiliteColor: 'Barva zvýraznění',
        clear: 'Vymazat',
        link: 'Odkaz',
        attach: 'Připojit soubor',
        tex: 'Vložit TeX',
        code: 'Kód',
        image: 'Vložit obrázek',
        insertHorizontalRule: 'Vložit vodorovnou čáru',
        superscript: 'Horní index',
        subscript: 'Dolní index',
        insertTable: 'Vložit tabulku',
        insertGroup: 'Vložit skupinu',
        hiliteGroup: 'Zvýraznit skupinu',
        removeGroup: 'Odstranit skupinu',
        insertAnchor: 'Vložit kotvu',
        mergeCells: 'Sloučit buňky',
        splitCells: 'Rozdělit buňky',
        rowsColumnsManaging: 'Správa řádků a sloupců',
        cellColor: 'Barva buňky',
        setDetails: 'Nastavit podrobnosti',
        removeDetails: "Odstranit podrobnosti",
    },
    editorEditLink: {
        urlExample: 'priklad.com',
        anchorExample: 'kotva',
    },
    editorTableCommands: [
        ['Vložit sloupec před', 'Vložit sloupec za'],
        ['Vložit řádek před', 'Vložit řádek za'],
        ['Odstranit sloupec', 'Odstranit řádek'],
    ],
    editorCodeOptions: ['Kód v textu', 'Blok kódu'],
    editorFontOptions: {
        small: 'Malé',
        large: 'Velké',
        normal: 'Normální',
        title: 'Nadpis',
        subtitle: 'Podnadpis',
    },
};

export const TUI_CZECH_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: 'Zobrazit/Skrýt',
    paginationTexts: {
        pages: 'Stránky',
        linesPerPage: 'Řádky na stránku',
        of: 'z',
    },
};

export const TUI_CZECH_LANGUAGE_CORE: TuiLanguageCore = {
    months: [
        'Leden',
        'Únor',
        'Březen',
        'Duben',
        'Květen',
        'Červen',
        'Červenec',
        'Srpen',
        'Září',
        'Říjen',
        'Listopad',
        'Prosinec',
    ],
    close: 'Zavřít',
    clear: 'Vymazat',
    nothingFoundMessage: 'Nenalezeny žádné výsledky',
    defaultErrorMessage: 'Neplatná hodnota',
    spinTexts: ['Předchozí', 'Další'],
    shortWeekDays: ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'],
    countries: {} as Record<TuiCountryIsoCode, string>,
};

export const TUI_CZECH_LANGUAGE: TuiLanguage = {
    name: 'czech',
    ...TUI_CZECH_LANGUAGE_CORE,
    ...TUI_CZECH_LANGUAGE_KIT,
    ...TUI_CZECH_LANGUAGE_ADDON_TABLE,
    ...TUI_CZECH_LANGUAGE_ADDON_COMMERCE,
    ...TUI_CZECH_LANGUAGE_ADDON_EDITOR,
    ...TUI_CZECH_LANGUAGE_LAYOUT,
};